var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareiconCropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(-597 -228)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(597 228)",
    fill: "#a08c73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-share_rounded",
    d: "M15.637,4.5a.6.6,0,0,0-.419.177L12.8,7.1a.6.6,0,1,0,.855.855L15.04,6.566l-.007,8.015a.6.6,0,1,0,1.21,0l.007-8.018,1.388,1.388a.6.6,0,1,0,.855-.855l-2.42-2.419A.6.6,0,0,0,15.637,4.5ZM12.218,9.541A2.227,2.227,0,0,0,10,11.758V18.21a2.227,2.227,0,0,0,2.218,2.218h6.855a2.227,2.227,0,0,0,2.218-2.218V11.758a2.227,2.227,0,0,0-2.218-2.218h-.807a.6.6,0,1,0,0,1.21h.807a1,1,0,0,1,1.008,1.008V18.21a1,1,0,0,1-1.008,1.008H12.218A1,1,0,0,1,11.21,18.21V11.758a1,1,0,0,1,1.008-1.008h.807a.6.6,0,1,0,0-1.21Z",
    transform: "translate(596.354 230.536)",
    fill: "#e3daca"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareiconCropped);
export default __webpack_public_path__ + "static/media/shareicon-cropped.2fc535b0b6eccb3d46ba63b1c25fc96d.svg";
export { ForwardRef as ReactComponent };